import React from 'react';

import axios from 'axios';
import Alert from 'components/Alert';
import { constants } from 'helpers/constants';

const ALUMY_API_URL = 'https://api.alumy.com/v1/partner/enrollments/resend';
const ALUMY_TOKEN = '7a695def38331fc23119960b2e55440952b55542';

export default class Alumy {
  public static isAlumy = (partnerId: number) => partnerId === constants.productPartners.alumy;

  public static alumyModal = async () => {
    const confirm = await Alert.confirm({
      message: 'Essa configuração deve ser feita na Alumy. Deseja continuar?',
      title: 'Produto Alumy',
      confirmation: true,
      buttonOk: <>Ir para alumy</>,
      buttonCancel: <>Cancelar</>
    });

    if (confirm) Alumy.openAlumy();
  };

  public static alumyModalDelivery = async () => {
    const confirm = await Alert.confirm({
      message: 'Para realizar esse tipo de entrega você deve acessar a tela de membros da Alumy',
      title: 'Acesse a Alumy',
      confirmation: true,
      buttonOk: <>Ir para alumy</>,
      buttonCancel: <>Cancelar</>
    });

    if (confirm) Alumy.openAlumy();
  };

  public static openAlumy = () => window.open('https://alumy.com/login', '_blank');

  public static alumyProductDelivery(id: number, emailCustomer: string): Promise<any> {
    return axios.request({
      method: 'post',
      url: ALUMY_API_URL,
      headers: {
        'token': ALUMY_TOKEN,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({ email: emailCustomer, cnt_cod: id })
    });
  }
}
